import React, { useState } from 'react';
import { ncService } from '../services/api';
import { showError } from '../utils/toast';

const OVERLAY = {
  position: 'fixed', inset: 0, background: 'rgba(15,23,42,.55)',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  zIndex: 1100, padding: '16px',
};
const BOX = {
  background: '#fff', borderRadius: '12px', padding: '28px 32px',
  maxWidth: '540px', width: '100%', boxShadow: '0 20px 60px rgba(0,0,0,.18)',
  display: 'flex', flexDirection: 'column', gap: '20px',
};
const LABEL = { fontSize: '13px', fontWeight: 600, color: '#334155', marginBottom: '6px', display: 'block' };
const TA = {
  width: '100%', border: '1px solid #cbd5e1', borderRadius: '8px',
  padding: '10px 12px', fontSize: '13px', color: '#1e293b',
  resize: 'vertical', minHeight: '80px', fontFamily: 'inherit', lineHeight: 1.5,
};
const BTN_ROW = { display: 'flex', gap: '10px', justifyContent: 'flex-end', flexWrap: 'wrap' };
const BTN_PRIM = {
  padding: '9px 20px', borderRadius: '8px', border: 'none',
  background: '#0f172a', color: '#fff', fontWeight: 600, fontSize: '13px', cursor: 'pointer',
};
const BTN_SEC = {
  padding: '9px 20px', borderRadius: '8px', border: '1.5px solid #cbd5e1',
  background: '#fff', color: '#475569', fontWeight: 600, fontSize: '13px', cursor: 'pointer',
};
const BTN_GHOST = {
  padding: '9px 20px', borderRadius: '8px', border: 'none',
  background: 'transparent', color: '#64748b', fontWeight: 600, fontSize: '13px', cursor: 'pointer',
};

export default function Preparar8DModal({ isOpen, onClose, ncId, metadados8d, onDownload }) {
  const [membros, setMembros] = useState(metadados8d?.d1_membros_extras || '');
  const [licoes, setLicoes] = useState(metadados8d?.d8_licoes_aprendidas || '');
  const [salvando, setSalvando] = useState(false);

  if (!isOpen) return null;

  const handleSalvarEBaixar = async () => {
    setSalvando(true);
    try {
      await ncService.editarAnalise(ncId, [
        { campo: 'metadados_8d.d1_membros_extras', valor: membros },
        { campo: 'metadados_8d.d8_licoes_aprendidas', valor: licoes },
      ]);
      onClose();
      await onDownload();
    } catch (err) {
      showError(`Erro ao salvar: ${err.message || 'tente novamente'}`);
    } finally {
      setSalvando(false);
    }
  };

  const handleSoBaixar = async () => {
    onClose();
    await onDownload();
  };

  return (
    <div style={OVERLAY} onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={BOX}>
        <div>
          <h2 style={{ margin: 0, fontSize: '17px', fontWeight: 700, color: '#0f172a' }}>
            Preparar Relatório 8D
          </h2>
          <p style={{ margin: '6px 0 0', fontSize: '13px', color: '#64748b' }}>
            Preencha os campos opcionais antes de baixar. Serão salvos na NC para a próxima exportação.
          </p>
        </div>

        <div>
          <label style={LABEL}>D1 — Membros adicionais da equipe</label>
          <textarea
            style={TA}
            placeholder="Ex: Maria Lima (Qualidade), João Costa (Produção)…"
            value={membros}
            onChange={e => setMembros(e.target.value)}
          />
          <span style={{ fontSize: '11px', color: '#94a3b8' }}>
            Complementa a equipe compilada automaticamente a partir dos responsáveis das ações.
          </span>
        </div>

        <div>
          <label style={LABEL}>D8 — Lições aprendidas e reconhecimento</label>
          <textarea
            style={{ ...TA, minHeight: '100px' }}
            placeholder="Ex: A padronização do processo reduziu reincidências em 60%. Reconhecemos a equipe pelo engajamento…"
            value={licoes}
            onChange={e => setLicoes(e.target.value)}
          />
          <span style={{ fontSize: '11px', color: '#94a3b8' }}>
            Texto livre — aparece no D8 do relatório no lugar do placeholder.
          </span>
        </div>

        <div style={BTN_ROW}>
          <button style={BTN_GHOST} onClick={onClose} disabled={salvando}>Cancelar</button>
          <button style={BTN_SEC} onClick={handleSoBaixar} disabled={salvando}>
            Só baixar
          </button>
          <button style={BTN_PRIM} onClick={handleSalvarEBaixar} disabled={salvando}>
            {salvando ? 'Salvando…' : 'Salvar e baixar'}
          </button>
        </div>
      </div>
    </div>
  );
}
